module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2017_professional_winner-d6162c2c89a6af62a1a88d559636b78c.jpg";